import { render, staticRenderFns } from "./AccountResetPass.vue?vue&type=template&id=4de92902&"
import script from "./AccountResetPass.vue?vue&type=script&lang=js&"
export * from "./AccountResetPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports